export default __webpack_public_path__ + "static/media/Approved-18.99f95866.svg";